
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Hint extends Vue {
  @Prop() hintHtml!: string
}
